import { CandidateType } from './Candidates/Candidates';

export const getChariotConnectId = (candidates: CandidateType[]) =>
  candidates?.length === 1 && candidates[0].misc_ids?.chariot_connect_id;

export const getChariotConnectIdFromSelectedCandidates = (candidates: CandidateType[]) => {
  const selectedCandidates =
    candidates.length === 1 ? candidates : candidates.filter(c => c.isSelected);
  if (selectedCandidates.length !== 1) {
    return undefined;
  }
  return selectedCandidates[0].misc_ids?.chariot_connect_id;
};
